import React, { useState } from 'react'
import { fadeInOut } from "../animations";
import { AnimatePresence, motion } from 'framer-motion';
import { Card, Typography } from "@material-tailwind/react";

const OrderData = ({ index, data, admin }) => {
    const orderDate = new Date(data.order_date._seconds * 1000);
    const options = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
    };
    const formattedOrderDate = orderDate.toLocaleString('en-GB', options);
    const totalMoney = data.orders.reduce((total, order) => {
        try {
            const price = parseInt(order.product_price);
            const quantity = order.quantity || 1;
            if (isNaN(price) || isNaN(quantity)) {
                // If price or quantity is not a valid number, return total
                return total;
            }
            return total + (price * quantity);
        } catch (error) {
            // Handle any other potential errors here
            console.error("Error calculating totalMoney:", error);
            return total;
        }
    }, 0);

    const TABLE_HEAD = ["Sản phẩm", "Loại", "số lượng", "Đơn giá"];
    const TABLE_ROWS = data.orders.map((item) => ({
        name: item.product_name,
        category: item.product_category,
        quantity: item.quantity,
        price: item.product_price
    }));
    const [expandPanel, setExpandPanel] = useState(false)
    return (
        <>
            <motion.div key={`data_${index}`}
                variants={fadeInOut}
                initial="hidden"
                animate="visible"
                exit="hidden"
                whileTap={{ scale: 0.95 }}
                onClick={() => setExpandPanel(!expandPanel)}
                className='w-full flex cursor-pointer z-10 flex-col items-start justify-start px-3 py-2 border relative border-gray-300 bg-lightOverlay drop-shadow-md rounded-md gap-4'
            >
                <div className='w-full flex items-center justify-between'>
                    <div className='flex flex-col'>
                        <h1 className='text-md text-headingColor'>{index + 1}.{data.phoneNumber}/{data.user?.name ? data.user?.name : " Vãng lai "}
                            {(data.user?.role === "admin" || data.user?.role === "Staff") && (<span className='px-2 rounded-md bg-emerald-200'>{data.user?.role}</span>)}
                        </h1>
                        <h1 style={{ whiteSpace: 'nowrap', maxWidth: '400px', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block' }}>
                            {data.orders.map(product => product.product_name).join(', ')}
                        </h1>

                        <span className='text-sm'>{formattedOrderDate}</span>
                    </div>

                    <div className='flex items-center gap-4'>
                        <p>Total: <span className='text-headingColor font-bold'>{totalMoney}</span> <span className='text-red-400'>VND</span></p>
                        <p className={`px-2 py-[2px] text-sm text-headingColor font-semibold capitalize rounded-md ${data.PaymentMethod === null ? "bg-red-500" : "bg-emerald-500"}  drop-shadow-md`}>{data.PaymentMethod === null ? ('Not paid') : (data.PaymentMethod)}</p>
                    </div>
                </div>
            </motion.div>
            <AnimatePresence>

                {expandPanel && (
                    <div className='overflow-y-hidden w-full'>
                        <motion.div className='z-1 w-full p-4'
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: 'auto', transition: { duration: 0.3 } }}
                            exit={{ opacity: 0, height: 0, transition: { duration: 0.3 } }}
                        >
                            <div className='mb-2'>
                                <h3>Thông tin khách hàng : </h3>
                                <div className='p-2 bg-white w-[300px] border-2 rounded-md'>
                                    <p className='text-[14px] text-orange-700'>Tên : {data.user?.name || "Vãng lai "}</p>
                                    <p className='text-[14px] text-orange-700'>SDT : {data.phoneNumber || "//"}</p>
                                    <p className='text-[14px] text-orange-700'>Địa chỉ giao hàng  : {data.address || "//"}</p>
                                </div>
                            </div>
                            <Card className="h-full w-full overflow-scroll">
                                <table className="w-full min-w-max table-auto text-left">
                                    <thead>
                                        <tr>
                                            {TABLE_HEAD.map((head) => (
                                                <th key={head} className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal leading-none opacity-70"
                                                    >
                                                        {head}
                                                    </Typography>
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {TABLE_ROWS.map(({ name, category, quantity, price }, index) => (
                                            !(quantity === 0) ? (
                                                <React.Fragment key={`tr_${name}`}>
                                                    <tr className="even:bg-blue-gray-50/50">
                                                        <td className="p-4">
                                                            <Typography variant="small" color="blue-gray" className="font-normal">
                                                                {name}
                                                            </Typography>
                                                        </td>
                                                        <td className="p-4">
                                                            <Typography variant="small" color="blue-gray" className="font-normal">
                                                                {category}
                                                            </Typography>
                                                        </td>
                                                        <td className="p-4">
                                                            <Typography variant="small" color="blue-gray" className="font-normal">
                                                                {quantity}
                                                            </Typography>
                                                        </td>
                                                        <td className="p-4">
                                                            <Typography variant="small" color="blue-gray" className="font-normal">
                                                                {price}
                                                            </Typography>
                                                        </td>
                                                        <td className="p-4">
                                                            <Typography as="a" href="#" variant="small" color="blue-gray" className="font-medium">
                                                                Edit
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            ) : null
                                        ))}
                                    </tbody>
                                </table>
                            </Card>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
        </>
    )
}

export default OrderData